import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Select from 'react-select';
import { buildUrl } from '../helper/handler';
import { getFromApi } from '../utilities/NetUtilities';
import { Settimane } from '../helper/settimaneTurniLavoro';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";


function FiltriPerSede(props) {

    const [sedi, setSedi] = useState([]);
    const [sede, setSede] = useState(null);
    const [settimana, setSettimana] = useState(null);
    const [settimanaCorrente, setSettimanaCorrente] = useState(null);
    const [settimaneConTurni, setSettimaneConTurni] = useState({});
    const [settimaneOptions, setSettimaneOptions] = useState(Settimane);
    const { setMessage } = props;
    const settimanaRef = useRef(settimana);
    
    useEffect(() => {
        settimanaRef.current = settimana;
    }, [settimana]);

    const handleSettimana = (data) => {
        const settimanaAttuale = Settimane.find(s => s.value === data.value);
        setSettimanaCorrente(settimanaAttuale);
        setSettimana(settimanaAttuale);
    };

    useEffect(() => {
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        getFromApi(buildUrl('settimanaCorrenteTurniLavoro'), handleSettimana, setMessageFromApi);
    }, [setMessage]);

    useEffect(() => {
        const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
        const setSediFromApi = (data) => {
            setSedi(data.sedi.map(sede => ({
                "value": sede.id,
                "label": sede.descrizione
            })));
        }
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        if (organizzazioneMap) {
            const url = buildUrl('sedi', { organizzazione: organizzazioneMap.nome, tipo: organizzazioneMap.tipo });
            getFromApi(url, setSediFromApi, setMessageFromApi);
        }
    }, [setMessage]);

    // Reset quando cambia sede
    useEffect(() => {
        if (sede) {
            setSettimaneOptions(Settimane);
            if (settimanaRef.current) {
                const baseSettimana = Settimane.find(s => s.value === settimanaRef.current.value);
                if (baseSettimana) {
                    setSettimana(baseSettimana);
                }
            }
        } else {
            setSettimaneOptions(Settimane);
            setSettimaneConTurni({});
        }
    }, [sede]);

    // Carica settimane con turni
    useEffect(() => {
        const setMessageFromApi = (data) => {
            setMessage(message => [...message, { tipo: data.messaggi[0].tipo, descrizione: data.messaggi[0].descrizione }])
        }
        const fetchSettimaneConTurni = (sedeId) => {
            const organizzazioneMap = JSON.parse(window.sessionStorage.getItem("organizzazione"));
            if (organizzazioneMap) {
                const url = buildUrl('settimaneConTurniPerSede', {
                    sede: sedeId,
                    organizzazione: organizzazioneMap.nome,
                    tipo: organizzazioneMap.tipo
                });

                getFromApi(url, handleSettimaneConTurni, setMessageFromApi);
            }
        };
        if (sede) {
            fetchSettimaneConTurni(sede.value);
        }
    }, [sede, props.refreshSettimaneConTurni, setMessage]);

    useEffect(() => {
        if (Object.keys(settimaneConTurni).length > 0) {
            const updatedSettimaneOptions = Settimane.map(settimana => {
                const settimanaInfo = settimaneConTurni[settimana.label];
                if (settimanaInfo && settimanaInfo.hasTurni) {
                    return {
                        ...settimana,
                        label: `${settimana.label} (totale ore: ${settimanaInfo.oreTotali})`,
                        oreTotali: settimanaInfo.oreTotali
                    };
                }
                return settimana;
            });
            setSettimaneOptions(updatedSettimaneOptions);
            if (settimanaRef.current) {
                const currentSettimanaIndex = updatedSettimaneOptions.findIndex(s => s.value === settimanaRef.current.value);
                if (currentSettimanaIndex !== -1) {
                    setSettimana(updatedSettimaneOptions[currentSettimanaIndex]);
                }
            }
        } else if (Object.keys(settimaneConTurni).length === 0 && settimanaRef.current) {
            // Reset alla settimana base quando non ci sono turni
            const baseSettimana = Settimane.find(s => s.value === settimanaRef.current.value);
            if (baseSettimana) {
                setSettimana(baseSettimana);
            }
        }
    }, [settimaneConTurni]);

    const handleSettimaneConTurni = (data) => {
        if (data && data.settimane) {
            const settimaneInfo = {};

            data.settimane.forEach(item => {
                settimaneInfo[item.settimana] = {
                    hasTurni: true,
                    oreTotali: item.oreTotali || "0:00"
                };
            });
            setSettimaneConTurni(settimaneInfo);
        }
    };

    const notificaFiltroChanged = (newSede, newSettimana) => {
        if (newSede && newSettimana) {
            props.filtroChanged(newSede, typeof newSettimana === 'object' ? newSettimana.value : newSettimana);
        }
    };

    const sedeChanged = (newSede) => {
        setSede(newSede);
        if (settimana) {
            notificaFiltroChanged(newSede, settimana);
        }
    };

    const settimanaChanged = (newSettimana) => {
        setSettimana(newSettimana);
        if (sede) {
            notificaFiltroChanged(sede, newSettimana);
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.data.value === (settimanaCorrente?.value || '') || state.isSelected
                ? '#e6f2ff'
                : state.data.oreTotali && state.data.oreTotali !== "0:00"
                    ? '#f7d3d4'
                    : provided.backgroundColor,
            fontWeight: state.data.value === (settimanaCorrente?.value || '') ||
                (state.data.oreTotali && state.data.oreTotali !== "0:00") ||
                state.isSelected
                ? 'bold'
                : 'normal',
            color: state.data.value === (settimanaCorrente?.value || '') ||
                (state.data.oreTotali && state.data.oreTotali !== "0:00") ||
                state.isSelected
                ? '#000000'
                : provided.color
        }),
    };

    const handlePrevSettimana = () => {
        if (!settimana) return;

        const currentIndex = settimaneOptions.findIndex(s => s.value === settimana.value);
        if (currentIndex > 0) {
            const prevSettimana = settimaneOptions[currentIndex - 1];
            setSettimana(prevSettimana);
            if (sede) {
                notificaFiltroChanged(sede, prevSettimana);
            }
        }
    };

    const handleNextSettimana = () => {
        if (!settimana) return;

        const currentIndex = settimaneOptions.findIndex(s => s.value === settimana.value);
        if (currentIndex < settimaneOptions.length - 1) {
            const nextSettimana = settimaneOptions[currentIndex + 1];
            setSettimana(nextSettimana);
            if (sede) {
                notificaFiltroChanged(sede, nextSettimana);
            }
        }
    };

    const handleTodaySettimana = () => {
        if (!settimanaCorrente) return;
        const settimanaAggiornata = settimaneOptions.find(s => s.value === settimanaCorrente.value) || settimanaCorrente;
        setSettimana(settimanaAggiornata);
        if (sede) {
            notificaFiltroChanged(sede, settimanaAggiornata);
        }
    };

    return (
        <Row className='filtri'>
            <Col xl={3} sm={4} xs={12} id="sede-filtro">
                <p className="inEvidenza">sede</p>
                <Select
                    id="sede-filtro-select"
                    name="sede"
                    instanceId="sede"
                    options={sedi}
                    onChange={sedeChanged}
                    placeholder="Seleziona..."
                    value={sede}
                />
            </Col>
            <Col xl={6} sm={8} xs={12} id="settimana-filtro">
                <p className="inEvidenza">settimana</p>
                <Select
                    id="settimana-filtro-select"
                    name="settimanainizio"
                    instanceId="settimana"
                    options={settimaneOptions}
                    onChange={settimanaChanged}
                    placeholder="Seleziona..."
                    value={settimana}
                    styles={customStyles}
                />
            </Col>
            <Col xl={3} sm={4} xs={12} id="settimana-navigazione" className="d-flex align-items-end">
                <Button 
                    id="precedente"
                    variant="primary" 
                    size="sm" 
                    title="indietro"
                    onClick={handlePrevSettimana} 
                    disabled={!settimana || Settimane.findIndex(s => s.value === settimana?.value) === 0}
                >
                    <FaChevronLeft></FaChevronLeft>
                </Button>
                <Button
                    id="oggi"
                    variant="outline-primary" 
                    size="sm" style={{
                    fontWeight: 'bold'
                    }}
                    onClick={handleTodaySettimana} 
                    disabled={!settimanaCorrente || (settimana && settimana.value === settimanaCorrente.value)}
                >
                    Oggi
                </Button>
                <Button 
                    id="successiva"
                    variant="primary" 
                    size="sm" 
                    title="avanti"
                    onClick={handleNextSettimana} 
                    disabled={!settimana || Settimane.findIndex(s => s.value === settimana?.value) === Settimane.length - 1}
                >
                    <FaChevronRight></FaChevronRight>
                </Button>
            </Col>
        </Row>
    )
}

export default FiltriPerSede;